<template>
  <v-form ref="form" v-model="valid">
    <v-container fluid>
      <nav>
        <v-app-bar app>
          <v-toolbar-title><v-breadcrumbs :items="items" large></v-breadcrumbs></v-toolbar-title>
        </v-app-bar>
      </nav>

      <v-card-title>General</v-card-title>
      <v-card>
        <v-row>
          <v-col cols="2">
            <v-subheader>SMP Console S/N</v-subheader>
          </v-col>
          <v-col cols="2">
            <v-select
              :items="serialNumber"
              item-value="serialNumber"
              :item-text="
                (serialNumber) => {
                  return serialNumber.serialNumber;
                }
              "
              v-model="consoleSn"
              label="Serial Number*"
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-subheader>SMP Console Label</v-subheader>
          </v-col>
          <v-col cols="2">
            <v-text-field v-model="consoleId"> </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-subheader>Location Name</v-subheader>
          </v-col>
          <v-col cols="2">
            <v-select
              :items="locationItem"
              item-value="_id"
              :item-text="
                (locationItem) => {
                  return locationItem.location;
                }
              "
              v-model="locationName"
              label="Location*"
            >
            </v-select>
          </v-col>
        </v-row>
      </v-card>

      <v-btn fixed dark fab bottom right color="blue" @click="saveItem()">
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
      <v-snackbar v-model="snackbar" top right :color="color">
        {{ text }}
        <v-btn color="black" text @click="snackbar = false">
          Dissmiss
        </v-btn>
      </v-snackbar>
    </v-container>
  </v-form>
</template>

<script>
  import axios from "axios";
  import router from "../../router";

  export default {
    data() {
      return {
        items: [
          {
            text: "Dashboard",
            disabled: false,
            href: "/",
          },
          {
            text: "Settings",
            disabled: true,
            href: "",
          },
          {
            text: "Seismic",
            disabled: false,
            href: "/smp-data",
          },
          {
            text: "Add",
            disabled: true,
            href: "",
          },
        ],
        consoleId: "",
        consoleSn: "",
        locationName: "",
        modifiedBy: "",

        valid: true,
        serialNumber: [],
        locationItem: [],
        sn: [],
        snackbar: false,
        text: "",
        color: "",
        showDeleteDialog: false,
      };
    },
    created() {
      this.loadsSerialNumber();
      this.loadsLocation();
      this.loadsSmp();
    },
    methods: {
      loadsLocation: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/location";
        axios
          .get(apiURL)
          .then((res) => {
            this.locationItem = res.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      loadsSerialNumber: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/serial-number-smp";

        try {
          const response = await axios.get(apiURL);
          const filteredSerialNumbers = response.data.filter((item) => /^0001\d{3}[3-5]\d$/.test(item.serialNumber));
          this.serialNumber = filteredSerialNumbers;
        } catch (error) {
          console.log(error);
        }
      },

      loadsSmp: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/smp-data";
        axios
          .get(apiURL)
          .then((res) => {
            this.sn = res.data.map((sn) => sn.consoleSn);
          })
          .catch((error) => {
            console.log(error);
          });
      },
      async saveItem() {
        if (this.$refs.form.validate()) {
          let apiURL = process.env.VUE_APP_API + "/api/create-smp-data";
          if (this.sn.indexOf(this.consoleSn) >= 0) {
            this.color = "warning";
            this.text = `Serial Number ${this.consoleSn} already existed!!`;
            this.snackbar = true;
          } else {
            axios.post(apiURL, {
              consoleId: this.consoleId,
              consoleSn: this.consoleSn,
              locationName: this.locationName,
              modifiedBy: this.$keycloak.tokenParsed.given_name,
            });
            router.go(-1);
          }
        }
      },
    },
  };
</script>
